"use client";

import { useState } from "react";

export default function HeroSection() {
  const [make, setMake] = useState("");
  const [model, setModel] = useState("");
  const [year, setYear] = useState("");

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    console.log({ make, model, year });
  };

  return (
    <section className="bg-background pt-32 xl:pt-[190px] pb-[120px] px-4 sm:px-6 lg:px-10">
      <div className="w-full max-w-[1440px] mx-auto">
        <div className="w-full flex flex-col lg:flex-row items-start justify-between gap-10 xl:gap-0 xl:h-[618px]">
          
          {/* Left Content */}
          <div className="flex flex-col justify-between gap-10 lg:gap-0 w-full xl:w-[710px] xl:h-[618px]">
            {/* Heading + Description */}
            <div className="flex flex-col gap-4 xl:gap-6">
              <h1 className="font-oswald font-medium text-[32px] sm:text-[42px] xl:text-[60px] leading-[1.2] xl:leading-[80px] tracking-[0.2px] uppercase text-neutral-500">
                FIND THE RIGHT GUNIWHEEL FIT FOR YOUR VEHICLE
              </h1>
              
              <div className="flex flex-col gap-4">
                <p className="font-roboto font-normal text-[14px] sm:text-[16px] xl:text-[18px] leading-[25px] text-neutral-300">
                  Select your vehicle's make, model, and year to instantly identify the correct Guniwheel size for safe and efficient workshop movement.
                </p>
                
                <p className="font-roboto font-normal text-[14px] sm:text-[16px] xl:text-[18px] leading-[25px] text-neutral-300">
                  Our advanced fitment tool analyzes thousands of bolt-pattern combinations to ensure you always choose the right universal wheel — every time.
                </p>
              </div>
            </div>

            {/* Form */}
            <form onSubmit={handleSubmit} className="flex flex-col gap-6">
              {/* Dropdowns - Gray Background */}
              <div className="bg-background-50 rounded-[12px] p-6 xl:p-8">
                <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
                  {/* Make */}
                  <div className="flex flex-col gap-2">
                    <label className="font-oswald font-medium text-[14px] xl:text-[16px] leading-[100%] tracking-[0.2px] uppercase text-neutral-500">
                      MAKE
                    </label>
                    <select
                      value={make}
                      onChange={(e) => setMake(e.target.value)}
                      className="w-full h-[50px] px-4 bg-white border-none rounded-[8px] font-roboto text-[14px] xl:text-[16px] text-neutral-300 focus:outline-none focus:ring-2 focus:ring-primary"
                    >
                      <option value="">Select vehicle</option>
                      <option value="toyota">Toyota</option>
                      <option value="honda">Honda</option>
                      <option value="ford">Ford</option>
                    </select>
                  </div>

                  {/* Model */}
                  <div className="flex flex-col gap-2">
                    <label className="font-oswald font-medium text-[14px] xl:text-[16px] leading-[100%] tracking-[0.2px] uppercase text-neutral-500">
                      MODEL
                    </label>
                    <select
                      value={model}
                      onChange={(e) => setModel(e.target.value)}
                      className="w-full h-[50px] px-4 bg-white border-none rounded-[8px] font-roboto text-[14px] xl:text-[16px] text-neutral-300 focus:outline-none focus:ring-2 focus:ring-primary"
                    >
                      <option value="">Select Model</option>
                      <option value="camry">Camry</option>
                      <option value="civic">Civic</option>
                      <option value="f150">F-150</option>
                    </select>
                  </div>

                  {/* Year */}
                  <div className="flex flex-col gap-2">
                    <label className="font-oswald font-medium text-[14px] xl:text-[16px] leading-[100%] tracking-[0.2px] uppercase text-neutral-500">
                      YEAR
                    </label>
                    <select
                      value={year}
                      onChange={(e) => setYear(e.target.value)}
                      className="w-full h-[50px] px-4 bg-white border-none rounded-[8px] font-roboto text-[14px] xl:text-[16px] text-neutral-300 focus:outline-none focus:ring-2 focus:ring-primary"
                    >
                      <option value="">Select Year</option>
                      <option value="2024">2024</option>
                      <option value="2023">2023</option>
                      <option value="2022">2022</option>
                    </select>
                  </div>
                </div>
              </div>

              {/* Submit Button - Outside Gray Background */}
              <button
                type="submit"
                className="w-full h-[60px] bg-primary hover:bg-primary/90 text-white font-oswald font-medium text-[14px] xl:text-[16px] uppercase rounded-[8px] transition-colors"
              >
                FIND MY WHEEL
              </button>
            </form>
          </div>

          {/* Right Image */}
          <div className="relative w-full lg:w-[580px] h-[300px] sm:h-[450px] xl:h-[618px] rounded-[12px] overflow-hidden">
            <img
              src="/image/fitment/hero-fitment.webp"
              alt="Guniwheel Fitment"
              className="w-full h-full object-cover"
            />
          </div>

        </div>
      </div>
    </section>
  );
}
